import {portal} from '../../core/portal.js';
import {getLocale} from '../../locale/model/locale.js';
import {authUser} from '../../userPool/context/auth-user.js';

export class LogEvent {
  constructor() {
    /**
     * @type {Window}
     * @private
     */
    this.window = window;

    /**
     * @type {string}
     */
    this.type = 'LogEvent';

    /**
     * @type {Screen}
     * @private
     */
    this.screen = screen;

    /**
     * @type {Navigator}
     * @private
     */
    this.navigator = window.navigator;

    /**
     * @type {string}
     * @private
     */
    this.url = this.window.location.hash.replace('#', '');
  }

  /**
   * Gets the screen dimensions.
   * @returns {ScreenSize}
   */
  getScreen() {
    return {
      width: this.screen.width,
      height: this.screen.height,
    };
  }

  /**
   * Gets the window dimensions and zoom level.
   * @returns {WindowSize}
   */
  getWindow() {
    return {
      width: this.window.innerWidth,
      height: this.window.innerHeight,
      zoom: this.window.devicePixelRatio,
    };
  }

  /**
   * Gets the user agent string.
   * @returns {string}
   */
  getUserAgent() {
    return this.navigator.userAgent;
  }

  /**
   * @returns {LogEventDTO}
   */
  getDTO() {
    return {
      type: this.type,
      screen: this.getScreen(),
      window: this.getWindow(),
      userAgent: this.getUserAgent(),
      url: this.url,
      locale: getLocale(),
      whitelabel: portal.id.toString(),
      user: authUser ? authUser.id.toString() : undefined,
    };
  }
}

/**
 * @typedef {Object} ScreenSize
 * @property {number} width
 * @property {number} height
 *
 * @typedef {Object} WindowSize
 * @property {number} width
 * @property {number} height
 * @property {number} zoom
 *
 * @typedef {Object} LogEventDTO
 * @property {string} type
 * @property {ScreenSize} screen
 * @property {WindowSize} window
 * @property {string} userAgent
 * @property {string} url
 * @property {string|null} locale
 * @property {string} whitelabel
 * @property {string=} user
 * @property {string=} amateurId
 * @property {string=} itemId
 * @property {number=} secs
 */
